import { PagerBaseComponent } from "~/app/open-age/core/structures";
import { Patient } from "./../../../open-age/telepain/models/patient";
import { FormControl } from "@angular/forms";
import { debounceTime, switchMap } from "rxjs/operators";
import { Practice } from "./../../../open-age/telepain/models/practice";
import { Practitioner } from "./../../../open-age/telepain/models/practitioner";
import { PractitionerService } from "./../../../open-age/telepain/services/practitioner.service";
import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
  ErrorHandler,
} from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material";
import { PracticeService } from "./../../../open-age/telepain/services/practice.service";
import { PatientService } from "~/app/open-age/telepain/services/patient.service";

@Component({
  selector: "app-quick-add-patients-dialog",
  templateUrl: "./quick-add-patients-dialog.component.html",
  styleUrls: ["./quick-add-patients-dialog.component.css"],
})
export class QuickAddPatientsDialogComponent extends PagerBaseComponent<Patient>
  implements OnInit {
  tab: "practice" | "prescriber" | "patient" = "practice";

  @ViewChild("userInput")
  userInput: ElementRef<HTMLInputElement>;

  patientSearchText: string = "";
  patients: Array<Patient> = [];
  items: any[];
  pager: any;
  isSubmitted: boolean;

  constructor(
    public dialogRef: MatDialogRef<QuickAddPatientsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private practitionerService: PractitionerService,
    private practiceService: PracticeService,
    api: PatientService,
    errorHandler: ErrorHandler
  ) {
    super({
      api,
      errorHandler,
      filters: ["practitionerId", "practiceId", "status", "name"],
      pageOptions: {
        limit: 6,
      },
    });
    this.afterFetching = () => {
      this.items.forEach(item => {
        if (this.searchPatient(item)) {
          item.isSelected = true
        }
      })
    }
  }

  ngOnInit() {
    this.onSearch();
  }

  close(val: boolean) {
    this.dialogRef.close(val);
  }

  resetPatient() {
    this.patientSearchText = null;
    this.onSearch();
  }

  onSearch(): void {
    this.currentPageNo = 1;
    this.filters.reset(false);
    if (this.patientSearchText) {
      this.filters.set("name", this.patientSearchText)
    }
    this.fetch().subscribe();
  }

  searchPatient(patient): boolean {
    let find = false
    this.patients.forEach(item => {
      if(item.role && item.role.id && patient.role && patient.role.id) {
        if (item.role.id == patient.role.id) {
          find = true
        }
      }
    })
    return find
  }

  back() {
    this.dialogRef.close()
  }

  onListItem(patient: any) {
    this.dialogRef.close({ patient: patient, isSuccess: true })
  }

}
